import CheckoutMNPDataModule from './mnpData'
import CheckoutPersonalDataModule from './personalData'
import CheckoutPaymentModule from './paymentData'
import CheckoutTariffModule from './tariff'
import CheckoutInfoModule from './activation/info'
import { CheckoutSubmitModule } from './flash/submit'
import ActivationIdentModule from '@/store/modules/checkout/activation/ident'
import { ActivationSubmitModule } from '@/store/modules/checkout/activation/submit'
import PromoCodeModule from '@/store/modules/promotion/promoCode'

const CheckoutModule = {
  namespaced: true,
  modules: {
    tariff: CheckoutTariffModule,
    mnpData: CheckoutMNPDataModule,
    personalData: CheckoutPersonalDataModule,
    paymentData: CheckoutPaymentModule,
    info: CheckoutInfoModule,
    ident: ActivationIdentModule,
    submit: CheckoutSubmitModule,
    activationSubmit: ActivationSubmitModule,
    promoCodeModule: PromoCodeModule
  },
  state: {
    view: 'checkoutMnpIn',
    process: 'checkout'
  },
  actions: {
    async resetCompleteCheckoutStore ({ state, commit }) {
      commit('mnpData/resetState', { root: true })
      commit('paymentData/resetState', { root: true })
      commit('personalData/resetState', { root: true })
      commit('ident/resetState', { root: true })
      commit('tariff/resetState', { root: true })
      commit('info/resetState', { root: true })
      commit('submit/resetState', { root: true })
      commit('promoCodeModule/resetState', { root: true })
      commit('promotion/promoCode/resetState', {}, { root: true })
      commit('kwk/resetState', {}, { root: true })
      commit('checkoutv2/ordering/_cart/resetState', {}, { root: true })
      commit('checkoutv2/activation/_cart/resetState', {}, { root: true })
      return true
    }
  },
  mutations: {
    goToStep (state, step) {
      if (typeof step !== 'undefined' && step !== null) {
        window.scrollTo(0, 0)
        const body = document.getElementById('top')
        body.scrollTop = 0
        const main = document.getElementById('main')
        main.scrollTop = 0
        const container = document.getElementById('main')
        container.scrollTop = 0
        const wrapper = document.getElementById('wrapper')
        wrapper.scrollTop = 0
        const inside = document.getElementById('mainInside')
        inside.scrollTop = 0
        state.view = step
      }
    },
    setStep (state, step) {
      if (typeof step !== 'undefined' && step !== null) {
        state.view = step
      }
    },
    setProcess (state, process) {
      state.process = process
    }
  },
  getters: {
    showCheckoutView: state => {
      return state.view
    },
    showProcess: state => {
      return state.process
    }
  }
}

export {
  CheckoutModule
}
